'use es6';

import LeadCostsRecord from 'AdsUI/records/LeadCostsRecord';
import Actions from 'AdsUI/lib/Actions';
const initialState = new LeadCostsRecord();
export default ((state = initialState, action) => {
  const {
    type,
    payload = {}
  } = action;

  switch (type) {
    case Actions.LEAD_COST_FETCH_SUCCEEDED:
      return state.merge(payload);

    default:
      break;
  }

  return state;
});